document.addEventListener('click', (e) => {
  const swatch = e.target.closest('.js-kik-color-swatch[data-variant-id]');
  if (!swatch) return;

  e.preventDefault();
  const productCard = swatch.closest('.product-card') || swatch.closest('.kik-cart-recommendation-card');
  if (!productCard) return;

  const variantId = swatch.dataset.variantId;
  const variantImage = swatch.dataset.variantImage;

  if (variantImage) {
    const mediaContainer = productCard.querySelector('.product-card__media') || productCard.querySelector('.kik-cart-recommendation-card__media');
    const lazyImage = mediaContainer?.querySelector('[is="lazy-image"]');
    const mainImage = mediaContainer?.querySelector('img');
    if (lazyImage) {
      lazyImage.src = variantImage;
      lazyImage.srcset = variantImage;
    } else if (mainImage) {
      mainImage.src = variantImage;
      mainImage.srcset = variantImage;
    }
  }

  const variantPrice = swatch.dataset.variantPrice;
  const variantCompareAtPrice = swatch.dataset.variantCompareAtPrice;
  if (variantPrice) {
    const priceContainer = productCard.querySelector('.price') || productCard.querySelector('.kik-cart-recommendation-card__price');
    if (priceContainer) {
      const fmt = (cents) => theme.utils.formatMoney(parseInt(cents), theme.settings?.moneyFormat || '${{amount}}').replace(/\$\s/g, '$ ');
      const regularEl = priceContainer.querySelector('.price__regular');
      const saleEl = priceContainer.querySelector('.price__sale');
      const onSale = variantCompareAtPrice && parseInt(variantCompareAtPrice) > parseInt(variantPrice);

      if (regularEl) regularEl.innerHTML = fmt(variantPrice);

      if (onSale) {
        priceContainer.classList.add('price--on-sale');
        if (saleEl) {
          saleEl.innerHTML = fmt(variantCompareAtPrice);
          saleEl.style.display = '';
        } else {
          const newSale = document.createElement('span');
          newSale.className = 'price__sale inline-flex items-center h-auto relative';
          newSale.innerHTML = fmt(variantCompareAtPrice);
          priceContainer.appendChild(newSale);
        }
      } else {
        priceContainer.classList.remove('price--on-sale');
        if (saleEl) saleEl.style.display = 'none';
      }
    }
  }

  productCard.querySelectorAll('.js-kik-color-swatch').forEach((item) => item.classList.remove('active'));
  swatch.classList.add('active');

  if (variantId) {
    const form = productCard.querySelector('form[is="product-form"], form[is="product-bundle-form"]');
    if (form) {
      const hiddenInput = form.querySelector('[name="id"]');
      if (hiddenInput) {
        hiddenInput.value = variantId;
        hiddenInput.setAttribute('value', variantId);
      }
    }

    productCard.querySelectorAll('button[data-variant-id]:not(.js-kik-color-swatch)').forEach((btn) => {
      btn.setAttribute('data-variant-id', variantId);
    });

    const variantsScript = productCard.querySelector('[data-product-variants]');
    const selectedVariantScript = productCard.querySelector('[data-selected-variant]');
    if (variantsScript && selectedVariantScript) {
      try {
        const variants = JSON.parse(variantsScript.textContent);
        const selectedVariant = variants.find((variant) => variant.id === parseInt(variantId));
        if (selectedVariant) {
          selectedVariantScript.textContent = JSON.stringify(selectedVariant);

          const bundleForm = productCard.querySelector('form[is="product-bundle-form"]');
          if (bundleForm) {
            const submitBtn = bundleForm.querySelector('[type="submit"]');
            if (submitBtn) {
              const btnText = submitBtn.querySelector('.btn-text span') || submitBtn.querySelector('.btn-text');
              if (selectedVariant.available) {
                submitBtn.removeAttribute('disabled');
                if (btnText && theme.variantStrings?.addToBundle) {
                  btnText.textContent = theme.variantStrings.addToBundle;
                }
              } else {
                submitBtn.setAttribute('disabled', '');
                if (btnText && theme.variantStrings?.soldOut) {
                  btnText.textContent = theme.variantStrings.soldOut;
                }
              }
            }
          }
        }
      } catch (error) {}
    }
  }
});

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.js-kik-buy-now');
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.disabled = true;
  btn.setAttribute('aria-busy', 'true');

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    });

    if (!res.ok) throw new Error('Add to cart failed');

    window.location.href = '/checkout';
  } catch (err) {
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
  }
});

window.addEventListener('pageshow', (e) => {
  if (e.persisted) {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
  }
});

(function () {
  const FLOATING_SELECTORS = ['#omnisend-forms-wrapper', '#ecomsend-widget', '#bon-loyalty-btn', '#Avada-FAQ_Widget', '#transcySwitcherContainer'];

  function setFloatingVisibility(hidden) {
    FLOATING_SELECTORS.forEach((selector) => {
      const el = document.querySelector(selector);
      if (el) el.style.setProperty('display', hidden ? 'none' : '', 'important');
    });
  }

  let hideCount = 0;

  document.addEventListener('kik-floating:hide', () => {
    hideCount++;
    setFloatingVisibility(true);
  });

  document.addEventListener('kik-floating:show', () => {
    hideCount = Math.max(0, hideCount - 1);
    if (hideCount === 0) setFloatingVisibility(false);
  });
})();
